import React from 'react';
import TrafficLandingTemplate, { LandingPageConfig } from './TrafficLandingTemplate';
import { Activity, BarChart3, Globe } from 'lucide-react';

const config: LandingPageConfig = {
    slug: 'tr/hedefli-trafik',
    titleTag: 'Hedefli Trafik Satın Al | Traffic Creator',
    metaDescription: 'Belirli bir ülkeden ziyaretçiye mi ihtiyacınız var? Devasa yerleşik IP ağımızdan geo-hedefli web sitesi trafiği satın alın. %100 gerçek insan davranışı.',
    keywords: 'Hedefli Trafik Satın Al, ABD Trafiği Satın Al, Türkiye Web Sitesi Trafiği, Ülkeye Göre Hedefli Trafik, Geo Targeted Traffic',
    primaryKeyword: 'Hedefli Trafik Satın Al',
    secondaryKeyword: 'TR Trafiği Satın Al',
    reviewCount: '601',
    ratingValue: '4.9',

    h1: 'Siteniz İçin En İyi Hedefli Trafiği Keşfedin',
    subheadline: 'Teknik sorunlarla uğraşmadan ABD ve Türkiye trafiğini yönetmeniz için gerekli araçları sağlıyoruz. Dünyanın her yerinden gerçek yerleşik ziyaretçiler alın.',

    problemH2: 'Neden Genel Trafik Büyümenizi Engelliyor?',
    problemText: 'İşletmeniz yalnızca Türkiye, ABD veya belirli bir yerel pazara hizmet veriyorsa genel dünya çapındaki trafik yararsızdır. Düşük kaliteli sağlayıcılar rastgele ülkelerden botlar göndererek hemen çıkma oranlarını artırır.',
    solutionPoints: [
        'Nokta atışı doğruluk: Türkiye, ABD, İngiltere ve Almanya dahil 150+ ülkeden hedefli trafik',
        'Coğrafi konuma mükemmel şekilde uyan gerçek yerleşik IP\'ler',
        'Ülkeye özgü ziyaretçilerle yerel SEO sinyallerini ve Google Haritalar otoritesini artırın',
        'Karışık dünya trafiğine kıyasla yüksek dönüşüm potansiyeli'
    ],

    featuresH2: 'Neden Bizim Hedefli Trafiğimizi Seçmelisiniz?',
    features: [
        { icon: <Globe />, title: 'Hassas Geo-Hedefleme', description: 'Belirli ülke ve bölgelerden gelen trafiği hassasiyetle yönlendirin. Analiz verilerinizi bozan alakasız ziyaretçilere veda edin.' },
        { icon: <Activity />, title: 'Yüksek Yerel Otorite', description: 'Arama motorlarına yerel otorite sinyali veren, sayfalarınızla gerçekten etkileşime giren ziyaretçiler alın.' },
        { icon: <BarChart3 />, title: 'Eşsiz Elde Tutma Oranları', description: 'Meşru yerleşik vekiller kullanarak daha iyi yerel SEO sinyalleri için hemen çıkma oranlarını düşürün.' }
    ],

    testimonialsH2: 'Müşterilerimiz Hedefli Trafik Hakkında Ne Diyor?',
    testimonials: [
        { name: 'Chloe B.', role: 'E-ticaret Sahibi', result: 'Yerelde 1. Sırada', text: 'ABD trafiği satın almak için bunu kullandığımdan beri yerel sıralamalarım fırladı. Google, sitemle etkileşime giren gerçek ABD IP\'lerini görüyor.', seed: 'chloeb_tr' },
        { name: 'Adam W.', role: 'Affiliate Pazarlamacı', result: '+300% Etkileşim', text: 'Belirli bir teklif için Türkiye trafiğine ihtiyacım vardı. Traffic Creator mükemmel hedefli ziyaretçiler sağladı.', seed: 'adamw_tr' },
        { name: 'Rachel T.', role: 'Yerel SEO Uzmanı', result: 'Mükemmel Konum Verisi', text: 'Diğerleri ülkeye göre trafik sunduğunu iddia ediyor ama kötü proxy kullanıyorlar. Burada IP\'ler gerçekten ülkeyle eşleşiyor.', seed: 'rachelt_tr' }
    ],

    ctaH2: 'En İyi Hedefli Trafiği Satın Almaya Hazır Mısınız?',

    faqs: [
        { question: 'Ülkeye göre hedefli trafik tam olarak nedir?', answer: 'Hedefli trafik, ziyaretçilerin yalnızca belirli coğrafi konumlardan gelecek şekilde filtrelenmesi demektir. Türkiye odaklıysanız, SEO için Türkiye trafiği almalısınız.' },
        { question: 'ABD trafiği satın almak güvenli mi?', answer: 'Evet! ABD, Türkiye ve 150+ ülkede bulunan yüksek kaliteli, gerçek yerleşik IP\'ler kullanıyoruz. %100 doğal görünür.' },
        { question: 'Geo-hedefleme yerel SEO\'ma nasıl yardımcı olur?', answer: 'Arama motorları ziyaretçi konumunu bir sıralama faktörü olarak kullanır. Belirli bir ülkeden gelen ziyaretler o pazardaki alakanızı güçlendirir.' },
        { question: 'Hedefli trafik Google Analytics\'te doğru görünecek mi?', answer: 'Kesinlikle. Gerçek yerleşik vekiller kullandığımız için GA4 ziyaretçilerin ülke ve şehir konumlarını doğru raporlayacaktır.' },
        { question: 'Aynı anda birden fazla ülkeyi hedefleyebilir miyim?', answer: 'Evet. Platformumuz belirli ülkeleri veya Avrupa veya Kuzey Amerika gibi bölgeleri seçmenize olanak tanır.' }
    ],

    relatedLinks: [
        { label: 'Web Sitesi Trafiği Satın Al', to: '/tr/web-sitesi-trafigi-satin-al' },
        { label: 'Yüksek Kaliteli Trafik', to: '/tr/yuksek-kaliteli-web-sitesi-trafigi' },
        { label: 'Yerel SEO Trafik Botu', to: '/tr/yerel-seo-trafik-botu' },
    ],

    productName: 'Geo-Hedefli Web Sitesi Trafiği',
    productDescription: 'Belirli bir ülkeden ziyaretçiye mi ihtiyacınız var? Yerleşik IP ağımızdan hedefli trafik satın alın.',

    translations: {
        navFeatures: 'Özellikler',
        navPricing: 'Fiyatlandırma',
        navFaq: 'SSS',
        navLogin: 'Giriş',
        heroBadge: 'Premium Geo-Targeted Traffic',
        heroCtaPrimary: 'Ücretsiz Deneyin',
        heroCtaSecondary: 'Fiyatları Gör',
        heroTrust: '10.000\'den fazla pazarlamacı bize güveniyor',
        heroMicrocopy: 'Kart gerekmez. %100 güvenli ve Analytics onaylı.',
        heroLiveLabel: 'Canlı',
        heroTrafficIncrease: 'Geo-Boost',
        heroActiveLabel: 'Aktif',
        heroVisitorsServed: 'Gönderilen Ziyaretçi',
        socialProofLabel: 'Partner Ajanslar:',
        problemWithout: 'Hedefleme Olmadan',
        problemWith: 'Hedefleme İle',
        problemBullets: [
            'Yanlış bölge nedeniyle yüksek hemen çıkma',
            'Yerel SEO için değersiz tıklar',
            'Bölgesel sıralamada iyileşme yok',
            'Yanlış ülkelere harcanan bütçe',
        ],
        statsCampaigns: 'Aktif Kampanyalar',
        statsCountries: 'Ülke Sayısı',
        statsUptime: 'Çalışma Süresi',
        statsSupport: 'Destek',
        featuresSubtitle: 'Hassas geo-hedefleme ile yerel erişiminizi en üst düzeye çıkarın.',
        howItWorksH2: 'Başarı İçin 3 Adım',
        howItWorksSteps: [
            { title: 'Ülke Seçin', desc: '150+ ülke arasından hedef bölgenizi seçin.' },
            { title: 'Hacmi Ayarlayın', desc: 'Günlük hedefli trafik miktarını belirleyin.' },
            { title: 'Sıralamaya Girin', desc: 'Yerel aramalarda konumunuzun yükselişini izleyin.' },
        ],
        pricingH2: 'Şeffaf Fiyatlandırma',
        pricingSubtitle: 'Tek seferlik alım. Abonelik yok. Krediler asla silinmez.',
        pricingMostPopular: 'En Çok Seçilen',
        pricingVisitors: 'Ziyaretçi',
        pricingGetStarted: 'Şimdi Başla',
        pricingGuarantee: 'Para İade Garantisi',
        pricingDelivery: 'Anında Teslimat',
        pricingCountries: '150+ Ülke',
        faqH2: 'Sıkça Sorulan Sorular',
        ctaSubtitle: 'Bölgesel pazarınıza bugün hükmetmeye başlayın.',
        ctaButtonPrimary: 'Ücretsiz Başla',
        ctaButtonSecondary: 'Tarifeleri Gör',
        footerDescription: 'Geo-hedefli web trafiği ve SEO için en yüksek kalite.',
        footerRelatedServices: 'Servisler',
        footerCompany: 'Şirket',
        footerAbout: 'Hakkımızda',
        footerBlog: 'Blog',
        footerHelpCenter: 'Yardım',
        footerPrivacy: 'Gizlilik',
        footerImpressum: 'Künye',
        footerStatus: 'Sistemler Çalışıyor',
        footerBuyTraffic: 'Trafik Satın Al',
    },
};

const TrGeoTargetedTraffic: React.FC = () => {
    return <TrafficLandingTemplate config={config} />;
};

export default TrGeoTargetedTraffic;
